export default {
  resumeMetadata: {
    formLabels: {
      aboutMe: 'Tell us about yourself',
      level: 'Education level',
      specialty: 'Specialty',
      company: 'Company name',
      dateFrom: 'Start date of work',
      dateTo: 'End date of work',
      untilNow: 'Until now',
      position: 'Position in the company',
      description: 'Description of work responsibilities',
    },
    successMessages: {
      editProfile: 'Profile data has been successfully changed',
      createEducation: 'Education successfully added',
      changeEducation: 'Education successfully edited',
      deleteEducation: 'Education successfully deleted',
      deletePortfolio: 'Portfolio successfully deleted',
      changeWorkExp: 'Work experience successfully changed',
      createWorkExp: 'Work experience successfully created',
      deleteWorkExp: 'Work experience successfully deleted',
    },
    errorMessages: {
      editProfile: 'Failed to change profile data',
      createEducation: 'Failed to add education',
      changeEducation: 'Failed to edit education',
      deleteEducation: 'Failed to delete education',
      deleteProtfolio: 'Failed to delete portfolio',
      changeWorkExp: 'Failed to change work experience',
      createWorkExp: 'Failed to create work experience',
      deleteWorkExp: 'Failed to delete work experience',
    },
    deleteEducationTitle: 'Delete the education?',
    addPortfolioButton: 'Add a portfolio item',
    deletePortfolioTitle: 'Delete the portfolio item?',
    addWorkExpButton: 'Add a work experience item',
    deleteWorkExpTitle: 'Delete the work experience item?',
    noWorkExp: 'No work experience',
    untilNow: 'until now',
  },
};
